export default __webpack_public_path__ + "static/media/Location_error.2de02413.svg";